import Queries from 'src/services/graphql/queries/index';
import { SuperUnitInput, ClientUnitInput } from 'src/services/graphql/Models';
import SuperUnit from './classes/SuperUnit';
import ClientUnit from './classes/ClientUnit';
import DataStoreExtension from './generic/datastore';
import { DocumentNode } from 'graphql';
import authStore from '../authStore';

export type UnitInput = SuperUnitInput | ClientUnitInput;
export type Unit = SuperUnit | ClientUnit;

class UnitStore extends DataStoreExtension <UnitInput,  Unit> {
    listQueries: DocumentNode =  Queries.ListUnits;
   
    _createQueries = Queries.CreateUnit;
    _deleteQueries = Queries.DeleteUnit;
    _updateQueries = () => authStore.isSuperUser ? Queries.UpdateUnitSuper : Queries.UpdateUnitClient;

    listVariables: any = () => {
        if (authStore.isSuperUser) {
            return {
                input:  {
                    unitId: 'UnitDetails',
                    typedId: 'un'
                }
            };
        }
        
        return {
            input: {
                clientId: authStore.clientId,
                typedId: 'un'
            }
        };
    }

    constructor() {
        super(false);
        this.subscriptionToUpdate(this.updateTypedItem('un', 'listUnits'));
    }

    toObject(from: SuperUnitInput | ClientUnitInput, index: number)
    : SuperUnit | ClientUnit {

        if (authStore.isSuperUser) {
            return new SuperUnit(from, index);
        } else {
            return new ClientUnit(from, index);
        }
    }

    countError(obj: SuperUnitInput | ClientUnitInput) {
        let errors = [];
        return errors;
    }

    parseDelete(obj: Unit) {
        return this.parseUnitDelete(obj);
    }
}

export default new UnitStore();


// WEBPACK FOOTER //
// ./src/stores/application/unit.ts